// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3zxpT","productName":"Table_productName__3jy95"};